import React from 'react'
import Skeleton from 'react-loading-skeleton'

const SkeletonReviewCard = (
  <div className='reviewCard skeletonCard' data-testid='skeleton-card'>
    <div className='reviewWrapper'>
      <div className='reviewContent'>
        <div className='reviewTop'>
          <div className='reviewHeader'>
            <div className='reviewHeaderLeft'>
              <Skeleton width={140} height={28} />
            </div>
            <div className='reviewHeaderRight'>
              <Skeleton width={40} height={40} />
            </div>
          </div>
          <div className='quote'>
            <Skeleton count={3} />
            <div style={{ width: '50%' }}>
              <Skeleton />
            </div>
          </div>
        </div>
        <div className='reviewBottom'>
          <div className='reviewBottomLeft'>
            <div className='relativeDate'>
              <Skeleton width={80} height={14} />
            </div>
            <div className='authorInfo'>
              <div className='authorAvatar'>
                <Skeleton circle width={48} height={48} />
              </div>
              <div className='authorDetails'>
                <Skeleton width={80} height={16} />
              </div>
            </div>
          </div>
          <div>
            <Skeleton width={70} height={20} />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default SkeletonReviewCard
